<template>
	<div class="row">
		<div class="col-12 col-sm-8 offset-sm-2 text-center">

	<div class="alert alert-timer">
		<div class="row justify-content-center">
			<div class="col-10">
				<template v-if="$gstate.getPaymentMethod() == 'CREDITCARD'">
					<strong>Current Price Quote</strong>
				</template>
				<template v-else>
					<strong>Current Price Expires in <span class="red"><cc-countdown @finished="finished" v-bind:end="endTime"></cc-countdown></span></strong>
				</template>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-10" v-if="$gstate.getTxnType() == 'BUY'">
				Spend {{ $gstate.getCurrencySymbol(pq.fiatCurrency) }}{{ pq.fiatAmount | num2decimal }} {{ pq.fiatCurrency }} to buy {{ pq.cryptoAmount | num8decimal }} {{ pq.cryptoCurrency }}
			</div>
			<div class="col-10" v-else-if="$gstate.getTxnType() == 'SELL'">
				Sell {{ pq.cryptoAmount | num8decimal }} {{ pq.cryptoCurrency }} to receive {{ $gstate.getCurrencySymbol(pq.fiatCurrency) }}{{ pq.fiatAmount | num2decimal }} {{ pq.fiatCurrency }}
			</div>
			<div class="col-10" v-else-if="$gstate.getTxnType() == 'SPEND'">
				Buy ${{ pq.fiatAmount | num2decimal }} {{ pq.fiatCurrency }} eGift Card for {{ pq.cryptoAmount | num8decimal }} {{ pq.cryptoCurrency }}
			</div>
		</div>
	</div>
	
		</div>
	</div>
</template>

<script>

import { eventBus } from './../main'

export default {
	data() {
		return {
			pq: this.$gstate.getFlowState()
		}
	},
	created(){
		eventBus.$on('refreshPq', this.refreshPq)
	},
	beforeDestroy(){
		eventBus.$off('refreshPq', this.refreshPq);
	},
	computed: {
		endTime: function (){

			// this should never happen
			if(this.$gstate.getFlowState().txnValidUntil === undefined){
				this.$gstate.log("Invalid txtValidUntil!");
				var tenMinutesLater = new Date();
				tenMinutesLater.setMinutes(tenMinutesLater.getMinutes() + 10);
				//tenMinutesLater.setSeconds(tenMinutesLater.getSeconds() + 3);
				return  tenMinutesLater;
			}
			
			return this.$moment(this.$gstate.getFlowState().txnValidUntil).toDate();

		},
	},
	methods: {
		finished (){
			this.$emit('finished');
		},
		refreshPq (){
			this.pq = this.$gstate.getFlowState();
		}
	}
}
</script>
